import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {metrics} from "react-metrics";
import config from 'config';
import getMetricsConfig from './metricsConfig';

/**
  This is to be used as a decorator for App It configures and then uses the provided `metrics` decorator
 */
export default function withAnalytics(ComposedComponent) {

  class WithAnalytics extends Component {

    static contextTypes = {
      store: PropTypes.object.isRequired
    }

    constructor(...args) {
      super(...args);

      this.metricsConfig = getMetricsConfig(this.context.store, config);

      this.metricsOptions = {
        useTrackBinding: false
      }

      this.metricsInstance = metrics(this.metricsConfig, this.metricsOptions)(ComposedComponent);
    }

    render() {
      const Metrics = this.metricsInstance;

      return <Metrics {...this.props} />;
    }
  }

  return WithAnalytics;
}



// WEBPACK FOOTER //
// ./utils/withAnalytics.js